<template>
  <v-list-item class="px-0 text-field-title">
    <v-list-item-icon class="py-0 mt-1 mb-0 d-flex align-center">
      <v-img
        v-if="image != undefined"
        class="px-0 py-0"
        height="18"
        width="18"
        contain
        :src="require(`@/assets/${image}`)"
      />
      <v-icon v-else>{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content class="py-0">
      <v-list-item-title> {{ title }}</v-list-item-title>
    </v-list-item-content>
    <!-- <v-list-item-action>
        <v-icon></v-icon>
    </v-list-item-action> -->
  </v-list-item>
</template>

<script>
export default {
  props: {
    image: { type: String },
    title: { type: String },
    hasIcon: { type: Boolean, default: false },
    icon: { type: String },
  },
};
</script>

<style scoped>
.text-field-title {
  height: 30px;
  min-height: 30px;
}
</style>
